import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SignInForm } from "./auth/SignInForm";
import { SignUpForm } from "./auth/SignUpForm";
import { useToast } from "@/hooks/use-toast";
import { logger } from '@/utils/logger';

interface AuthProps {
  defaultTab?: "signin" | "signup";
}

export const Auth = ({ defaultTab = "signin" }: AuthProps) => {
  const [isLoading] = useState(false);
  const { toast } = useToast();

  const handleSignUpSuccess = () => {
    logger.info('User signed up successfully', { component: 'Auth', action: 'signUp' });
    toast({
      title: "Account created",
      description: "Please verify your email to continue.",
    });
  };

  return (
    <div className="space-y-6 animate-fade-in">      
      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2 mb-6 p-1 bg-muted">
          <TabsTrigger 
            value="signin" 
            className="data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:shadow-sm"
          >
            Sign In
          </TabsTrigger>
          <TabsTrigger 
            value="signup"
            className="data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:shadow-sm"
          >
            Sign Up
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="signin" className="animate-fade-in">
          <SignInForm />
        </TabsContent>
        
        <TabsContent value="signup" className="animate-fade-in">
          <SignUpForm onSuccess={handleSignUpSuccess} />
        </TabsContent>
      </Tabs>
    </div>
  );
};